import { useState } from 'react';
import { Card, Collapse } from 'react-bootstrap';
import { AuditLogEntityDetail } from '../models/auditLog.model';
import { AuditDiffViewer } from './AuditDiffViewer';
import { Badge } from 'react-bootstrap';
import { getOperationKind } from '../utils/auditLogHelpers';

const opVariant: Record<ReturnType<typeof getOperationKind>, string> = {
    create: 'success',
    update: 'primary',
    delete: 'danger',
    unknown: 'secondary',
};

interface Props {
    entities: AuditLogEntityDetail[];
}

/** Registros relacionados en la misma acción (correlación); colapsados por defecto. */
export function RelatedAuditEntitiesPanel({ entities }: Props) {
    const related = entities.slice(1);
    if (!related.length) {
        return null;
    }

    return (
        <Card className='mt-3'>
            <Card.Header className='py-2'>
                <span className='fw-medium'>Registros relacionados en la misma operación</span>
                <Badge bg='secondary' className='ms-2'>
                    {related.length}
                </Badge>
            </Card.Header>
            <Card.Body className='pt-2'>
                {related.map((ent) => (
                    <RelatedEntityBlock key={`${ent.id}-${ent.entityName}-${ent.primaryKey}`} entity={ent} />
                ))}
            </Card.Body>
        </Card>
    );
}

function RelatedEntityBlock({ entity }: { entity: AuditLogEntityDetail }) {
    const [open, setOpen] = useState(false);
    const kind = getOperationKind(entity.operation);

    return (
        <div className='border rounded mb-2 overflow-hidden'>
            <button
                type='button'
                className='w-100 text-start btn btn-light d-flex justify-content-between align-items-center py-2 px-3'
                onClick={() => setOpen(!open)}
                aria-expanded={open}
            >
                <span>
                    <i className={`ri-arrow-${open ? 'down' : 'right'}-s-line me-1`} />
                    <span className='fw-medium'>{entity.entityName}</span>
                    <span className='text-muted small ms-2'>PK {entity.primaryKey}</span>
                </span>
                <Badge bg={opVariant[kind]}>{entity.operationDescription}</Badge>
            </button>
            <Collapse in={open}>
                <div className='px-2 pb-2'>
                    <AuditDiffViewer fields={entity.fields} />
                </div>
            </Collapse>
        </div>
    );
}
